<template>
  <div class="box">
    <div class="title">{{ $t("index.为探索而生") }}</div>
    <ul class="smalltitle">
      <li>
        <p class="headline">{{ $t("index.零售中心") }}</p>
        <p class="content">
          {{ $t("index.找到距离您最近的格物销售和服务中心") }}
        </p>
        <p>
          <img src="../../../assets/imgs/ForExplore01.png" />
        </p>
      </li>
      <li>
        <p class="headline">{{ $t("index.金融计算器") }}</p>
        <p class="content">{{ $t("index.多种贷款方式，总有一款适合您") }}</p>
        <p>
          <img src="../../../assets/imgs/ForExplore02.png" />
        </p>
      </li>
      <li>
        <p class="headline">{{ $t("index.参数配置") }}</p>
        <p class="content">
          {{ $t("index.查看参数配置，选择更适合您的摩托车") }}
        </p>
        <p>
          <img src="../../../assets/imgs/ForExplore03.png" />
        </p>
      </li>
    </ul>
  </div>
</template>
  
  <script>
export default {};
</script>
  
  <style lang='scss' scoped>
@import "~@assets/styles/func.scss";
img {
  vertical-align: top;
}
.box {
  width: 100vw;
  text-align: center;
  background-color: #fff;
  .title {
    font-family: PingFang-SC-Medium;
    font-size: px2rem(34px);
    line-height: px2rem(80px);
  }
  .smalltitle {
    width: 94%;
    margin: 0 auto;
    padding: 0 0;
    li {
      padding: 5vw 0;
      font-size: px2rem(18px);
      p {
        text-align: left;
        width: 100%;
        img {
          width: 100%;
        }
      }
      .headline {
        font-family: PingFang-SC-Bold;
        font-weight: bold;
        font-size: px2rem(22px);
        line-height: px2rem(40px);
        margin-top: px2rem(5px);
        margin-left: px2rem(24px);
      }
      .content {
        font-family: PingFang-SC-Regular;
        font-weight: regular;
        font-size: px2rem(18px);
        margin-left: px2rem(24px);
        margin-bottom: px2rem(10px);
        color: #666666;
      }
    }
    li:hover {
      cursor: pointer;
    }
  }
}
</style>